import React from 'react';
import { Page, BText } from '../../components';

export const AdminHome = () => {
  return (
    <Page title={'Admin Home'}>
      <BText>Content</BText>
    </Page>
  );
};
